import { Injectable } from '@angular/core';
import { HttpClientService } from '@core/services/http-client/http-client.service';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
import { DataGrid } from '@sharedModule/models/data-grid.model';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { removeEmptyStrings } from '@sharedModule/utils/form.utils';
import { Observable } from 'rxjs';
import { ConversionRateInterface } from '../types/currency-conversion-rate';
import {
  ConversionRateFilter,
  defaultConversionRateFilter,
} from '../types/currency-conversion-rate-filter';
import { UpsertConversionRateInterface } from '../types/upsert-currency-conversion-rate';
import { UpsertDestCountryInterface } from '../types/upsert-destination-country';
import { UpsertSourceCountryInterface } from '../types/upsert-source-country';

@Injectable({
  providedIn: 'root',
})
export class CountrySettingsService {
  constructor(private httpClient: HttpClientService) {}

  addSourceCountry(
    payload: UpsertSourceCountryInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.addSourceCountry,
      payload
    );
  }

  updateSourceCountry(
    payload: UpsertSourceCountryInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.updateSourceCountry,
      payload
    );
  }

  deleteSourceCountry(payload: {
    srcCountryName: string;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.deleteSourceCountry,
      payload
    );
  }

  addDestCountry(
    payload: UpsertDestCountryInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.addDestinationCountry,
      payload
    );
  }

  updateDestCountry(
    payload: UpsertDestCountryInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.updateDestinationCountry,
      payload
    );
  }

  deleteDestCountry(payload: {
    srcCountryName: string;
    destCountryName: string;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.deleteDestinationCountry,
      payload
    );
  }

  getConversionRate(
    payload: ConversionRateFilter = defaultConversionRateFilter
  ): Observable<ResponseIdentity<DataGrid<ConversionRateInterface[]>>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.getConversionRate,
      removeEmptyStrings(payload)
    );
  }

  addConversionRate(
    payload: UpsertConversionRateInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.addConversionRate,
      payload
    );
  }

  updateConversionRate(
    payload: UpsertConversionRateInterface
  ): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.updateConversionRate,
      payload
    );
  }

  deleteConversionRate(payload: {
    id: number;
  }): Observable<ResponseIdentity<null>> {
    return this.httpClient.post(
      API_URL_CONSTANT.countrySettings.deleteConversionRate,
      payload
    );
  }
}
